import { videoAssetUploadOptions } from "./assets";
import { FieldMediaAsset, type FieldMediaAssetProps } from "./FieldMediaAsset";

type FieldVideoAssetProps = Omit<FieldMediaAssetProps, "uploadOptions" | "type"> & {
  uploadOptions?: FieldMediaAssetProps["uploadOptions"];
};

export const FieldVideoAsset = ({ uploadOptions = videoAssetUploadOptions, ...props }: FieldVideoAssetProps) => (
  <FieldMediaAsset {...{ ...props, uploadOptions, type: "video" }} />
);
